import Flex from 'legacyfrontend/components/Flex';
import SlickImageGallery from 'legacyfrontend/components/slick-image-gallery';

const ImageGallery = ({ items, title }) => {
  if (items.length === 0) return null;

  return (
    <Flex className='card-box banner-information__gallery' vertical>
      <SlickImageGallery items={items} title={title} />
    </Flex>
  );
};

export default ImageGallery;
